import { render, staticRenderFns } from "./JeecgOrderTicketList.vue?vue&type=template&id=7dc67b70&scoped=true&"
import script from "./JeecgOrderTicketList.vue?vue&type=script&lang=js&"
export * from "./JeecgOrderTicketList.vue?vue&type=script&lang=js&"
import style0 from "./JeecgOrderTicketList.vue?vue&type=style&index=0&id=7dc67b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc67b70",
  null
  
)

export default component.exports